import styled from '@emotion/styled'

import { TYPOGRAPHY_18 } from 'theme/theme'

export const Text = styled.div`
  ${TYPOGRAPHY_18}

  color: ${props => props.link ? '#0bf' : '#A0A5B3'};
`

export const ActionsWrapper = styled.div`
  display: flex;
  margin-top: 40px;
  align-items: center;

  @media (max-width: 525px) {
    flex-direction: column;
    justify-content: center;
  }
`

export const TextWrapper = styled.div`
  display: flex;
  margin-top: 12px;
`

export const Or = styled.div`
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  color: #0bf;
  margin-top: 28px;
  margin-bottom: 30px;
`
